import { observer } from 'mobx-react-lite'
import { getRequestDraftReturnText } from '@/features/jobs/details/components/JobProgressionCard/request-draft-return-text'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { match } from '@/utils/pattern-match-util'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import {
  JobStartedEssentialActions,
  JobStartedPreparationActions,
  JobStartedRetailOutsourcingActions,
} from '@/features/jobs/details/components/JobProgressionCard/JobStartedProgressionActions'

export interface JobStartedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const JobStartedProgressionActionsContainer = observer(
  function JobStartedProgressionActionsContainer({
    vm,
  }: JobStartedProgressionActionsContainerProps) {
    const retailOutsourcingActions = () => (
      <JobStartedRetailOutsourcingActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        hasDraftReturn={vm.hasDraftReturn}
        isDraftReturnDownloadable={vm.isDraftReturnDownloadable}
        requestDraftApprovalLabel={getRequestDraftReturnText(
          vm.hasDraftReturn,
          vm.isDraftReturnDownloadable,
          vm.currentProgressionFlow,
        )}
        onReportOpenItems={vm.reportOpenItems}
        onRequestDraftApproval={vm.answerDraftInReview}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
          )
        }
      />
    )

    return match(vm.currentProgressionFlow, {
      Outsourcing: retailOutsourcingActions,
      Retail: retailOutsourcingActions,
      Essential: () => (
        <JobStartedEssentialActions
          onUploadDocuments={vm.viewReturnFiledDocumentCreationModal}
          testId={`job-progression-${vm.currentProgressionFlow}-close-job-button`}
        />
      ),
      Preparation: () => (
        <JobStartedPreparationActions
          isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
          onReportOpenItems={vm.reportOpenItems}
          onPreparationCompleted={vm.viewReturnFiledDocumentCreationModal}
          extensionActions={
            vm.isAnyExtensionFlowAvailable && (
              <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
            )
          }
        />
      ),
      Review: retailOutsourcingActions,
      None: () => null,
      PersonalExtension: () => null,
      BusinessExtension: () => null,
      OutsourcingExtension: () => null,
    })
  },
)
